import classNames from 'classnames/bind';
import styles from './FooterButton.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const FooterButton = (props: Props) => {
  return <div>Footer Button</div>;
};

export default FooterButton;
